// src/Pages/Landing/JoyrideEtelaKarjalaLanding.jsx
import React from "react";
import JoyrideMaakuntaLanding from "./JoyrideMaakuntaLanding.jsx";

export default function JoyrideEtelaKarjalaLanding() {
  return (
    <JoyrideMaakuntaLanding
      maakunta="Etelä-Karjala"
      cities={[
        "Lappeenranta",
        "Imatra",
        "Lemi",
        "Luumäki",
        "Savitaipale",
        "Taipalsaari",
        "Ruokolahti"
      ]}
      regionText="Bilebändi Joyride tekee keikkoja myös Etelä-Karjalan alueelle tapahtuman luonteesta, aikataulusta ja matkasta riippuen. Lappeenrannan ja Imatran seutu sopivat hyvin esimerkiksi häihin, yritysjuhliin, kesäjuhliin ja pikkujouluihin, kun juhliin halutaan energinen livebändi."
      bookingLink="/#varaa"
    />
  );
}